import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Guard de autenticación para el subárbol de rutas del comercio.
 *
 * Reemplaza al patrón previo donde cada página dependía de `AppLayout` para
 * forzar el redirect a /login. Si una página nueva olvidaba envolverse en
 * AppLayout, quedaba accesible sin sesión. Centralizar el guard en App.tsx
 * elimina ese riesgo: las rutas anidadas se renderizan sólo cuando hay user
 * verificado, sin importar lo que haga el componente hoja.
 *
 * - Mientras `isLoading`: render mínimo para evitar flash a /login durante el
 *   bootstrap del AuthContext (que recupera el token de localStorage).
 * - Sin user → /login.
 * - Con user pero sin email verificado → /verify-email.
 */
export default function ProtectedRoute() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background-light dark:bg-background-dark flex items-center justify-center">
        <div className="flex items-center gap-2 text-primary">
          <span className="material-symbols-outlined text-3xl animate-spin">progress_activity</span>
          <span className="text-sm font-medium text-slate-500">Cargando...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!user.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  return <Outlet />;
}
